<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>


    require('@/sass/app.scss')
    export default {
        components: {
        }
    }



</script>

